<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9158_9528)">
      <path
        d="M0 9.84683C0 5.32133 0 3.0586 1.40589 1.65271C2.81177 0.246826 5.0745 0.246826 9.6 0.246826H10.4C14.9255 0.246826 17.1882 0.246826 18.5941 1.65271C20 3.0586 20 5.32133 20 9.84683V10.6468C20 15.1723 20 17.435 18.5941 18.841C17.1882 20.2468 14.9255 20.2468 10.4 20.2468H9.6C5.0745 20.2468 2.81177 20.2468 1.40589 18.841C0 17.435 0 15.1723 0 10.6468V9.84683Z"
        fill="#0077FF"
      />
      <path
        d="M10.6416 14.6552C6.08329 14.6552 3.48333 11.5302 3.375 6.3302H5.65833C5.73333 10.1469 7.41663 11.7635 8.74996 12.0969V6.3302H10.9V9.62187C12.2167 9.4802 13.5999 7.9802 14.0665 6.3302H16.2166C15.8582 8.36353 14.3582 9.86353 13.2916 10.4802C14.3582 10.9802 16.0667 12.2885 16.7167 14.6552H14.3499C13.8416 13.0719 12.575 11.8469 10.9 11.6802V14.6552H10.6416Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_9158_9528">
        <rect width="20" height="20" fill="white" transform="translate(0 0.246826)" />
      </clipPath>
    </defs>
  </svg>
</template>
